import { useMemo, useState } from "react";
import { COUNTRY_LIST } from "../lib/locale";
import { ChevronDown } from "lucide-react";

export default function CountrySelect({ value, onChange, testid, placeholder = "— Choose country —" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const filtered = useMemo(() => {
    if (!q.trim()) return COUNTRY_LIST;
    const needle = q.toLowerCase();
    return COUNTRY_LIST.filter((c) => c.toLowerCase().includes(needle));
  }, [q]);

  return (
    <div className="relative" data-testid={testid ? `${testid}-wrap` : undefined}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={testid}
        className="w-full text-left btw-input flex items-center justify-between"
      >
        <span className={value ? "" : "text-[#6b6560]"}>{value || placeholder}</span>
        <ChevronDown size={14} className="text-[#5c5852]" />
      </button>
      {open && (
        <div
          className="absolute z-30 left-0 right-0 mt-1 bg-white border border-[#dcd3c6] shadow-sm max-h-72 overflow-auto"
          data-testid={testid ? `${testid}-list` : undefined}
        >
          <input
            autoFocus
            aria-label="Search country"
            placeholder="Search country…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Escape") { setOpen(false); setQ(""); } }}
            className="w-full px-3 py-2 border-b border-[#dcd3c6] text-sm outline-none"
            data-testid={testid ? `${testid}-search` : undefined}
          />
          {filtered.slice(0, 80).map((c) => (
            <button
              key={c}
              type="button"
              onMouseDown={() => { onChange(c); setOpen(false); setQ(""); }}
              onClick={() => { onChange(c); setOpen(false); setQ(""); }}
              className={`w-full text-left px-3 py-1.5 text-sm hover:bg-[#f5f3ed] ${value === c ? "text-[#876a4f]" : ""}`}
            >
              {c}
            </button>
          ))}
          {filtered.length === 0 && (
            <div className="px-3 py-3 text-xs italic text-[#5c5852]">No match.</div>
          )}
        </div>
      )}
    </div>
  );
}
